import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

type TabsTriggerProps = ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
  icon?: ReactNode;
};

export const TabsTrigger = ({ className, children, icon, ...props }: TabsTriggerProps) => (
  <TabsPrimitive.Trigger
    className={cn(
      // Base styles
      'inline-flex min-h-[29px] min-w-[29px] items-center justify-center gap-1.5 rounded-[10px] px-2 py-1',
      'cursor-pointer whitespace-nowrap font-medium text-sm transition-all',
      // Inactive state
      'text-stone-700',
      // Active state
      'data-[state=active]:bg-white data-[state=active]:text-stone-700',
      'data-[state=active]:shadow-sm',
      // Focus state
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 focus-visible:ring-offset-2',
      // Hover state
      'hover:bg-stone-50',
      // Disabled state
      'disabled:pointer-events-none disabled:opacity-50',
      className,
    )}
    {...props}
  >
    {icon && <span className="shrink-0">{icon}</span>}
    {children}
  </TabsPrimitive.Trigger>
);
